module.exports = __webpack_public_path__ + "static/page_ats-eb60a1a142db3a9ec04945af11d1cd70.png";